import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import firebase from "./firebase";
import fapi from './firebase/api';

import './scss/custom.scss';

Vue.use(BootstrapVue);

Vue.config.productionTip = false


// fapi.init(firebase.auth, firebase.db, firebase.storage);
fapi.init(firebase);
Vue.prototype.$fapi = fapi;

// Vue.prototype.$auth = fbServices.auth;
// Vue.prototype.$db = fbServices.db;
// Vue.prototype.$storage = fbServices.storage;

createAppStatusListener(fapi, store);



var app = null;

fapi.onAuthStateChanged(function (user) {
  if (user) {
    // User is signed in.
    store.dispatch('auth/setAuthUser', user);
    store.dispatch('auth/setAuthUserEmail', user.email);
    fapi.user = user;

    // console.log('MODEL', model);
    // model.getImageUploadDocs();

    // model.initUploadsImgUrlCache(); // remove this
    // model.getImageUploadsCounts();

    // testDocUpdates();
  } else {
    // User is signed out.
    // model.user = null;
    store.dispatch('auth/setAuthUser', null);
    store.dispatch('auth/setAuthUserEmail', '');

    localStorage.removeItem('refCode');
    // localStorage.removeItem('refByCode');

    fapi.user = null;
    console.log('no user?', user)

    // Detach document listeners
    // model.docListeners.imageCounts();

    // for (let f in model.docListeners) {
    //     model.docListeners[f]();
    // }
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

});


async function createAppStatusListener(fapi, store) {
  var appStatusDocRef = fapi.getDocRefById('appStatus', 'client');
  var appStatusDoc = await appStatusDocRef.get();
  var appStatusDocListener = appStatusDocRef.onSnapshot(function (appStatusDoc) {
    store.dispatch('setAppActive', appStatusDoc.data().appActive);
    store.dispatch('setUploadSvcActive', appStatusDoc.data().uploadSvcActive);
  })
  store.dispatch('setDocListener', {
    appStatus: appStatusDocListener,
  });
}


// var user;
// user = { username: 'gpajor', email: 'gary.pajor@gmail.com' };

// var authChanged = true;

// if (authChanged) {
//   // firebase.auth.onAuthStateChanged(function (user) {
//   if (user) {
//     // User is signed in.
//     // Set user in auth state 
//     console.log('there IS a user:', user)
//     store.dispatch('auth/setAuthUser', user);
//     // Set user in FB services, i.e. this was FBase.js (imported as FB) in prototype dev project

//   } else {
//     // User is signed out.
//     // Unset user in auth state 
//     //store.dispatch('auth/unsetAuthUser');
//     // Unset user in FB services (NEED TO DO THIS??)
//   }
//   // console.log('auth user from store:', store.getters['auth/authUser'])
//   if (!app) {
//     app = new Vue({
//       router,
//       store,
//       render: h => h(App)
//     }).$mount('#app')
//   }

//   // });
// }